<template>
  <div class="modal-backdrop" @click.self="close">
    <div class="modal-content">
      <h3>Nova Tarefa</h3>
      <form @submit.prevent="submitForm">
        <div class="row">
          <!-- <div class="col-2">
            <label for="id">ID</label>
            <input type="text" id="id" v-model="form.colaborador_id" required placeholder="ID" readonly>
          </div> -->
          <div class="col">
            <label for="titulo">Título</label>
            <input id="titulo" type="text" v-model="form.nome" required placeholder="Digite o título" />
          </div>
          <div class="col">
            <label for="status">Status</label>
            <select id="status" v-model="form.status" required>
              <option value="" disabled>Selecione</option>
              <option value="PENDENTE">PENDENTE</option>
              <option value="CONCLUIDO">CONCLUIDO</option>
            </select>
          </div>
        </div>

        <label for="descricao">Descrição</label>
        <textarea id="descricao" cols="30" rows="10" v-model="form.descricao"
          placeholder="Digite a descrição"></textarea>

        <div class="row">
          <div class="col">
            <label for="data">Data de previsão</label>
            <flat-pickr id="data" v-model="form.data_previsao" :config="config" />
          </div>
        </div>

        <div class="buttons">
          <button type="submit">Salvar</button>
          <button type="button" @click="close">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { defineEmits, defineProps } from "vue";
import { useStorage } from "vue3-storage";

import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

import services from "../../services";

const props = defineProps({
  colaboradores: {
    type: Array,
    required: true,
  },
  colaboradorId: {
    type: [String, Number],
    default: "",
  },
});

const emit = defineEmits("close");

const storage = useStorage();
const token = storage.getStorageSync("token");
const atribuidorId = storage.getStorageSync("colaborador_id");
alert(atribuidorId);

const form = reactive({
  colaborador_id: props.colaboradorId || "",
  nome: "",
  descricao: "",
  status: "",
  atribuidor_id: atribuidorId,
  data_previsao: null,
});

const config = {
  locale: Portuguese,
  dateFormat: "Y-m-d",
  altInput: true,
  altFormat: "d/m/Y",
  allowInput: true,
};

async function submitForm() {
  try {
    let formattedDate = null;
    if (form.data_previsao) {
      const selectedDate = new Date(form.data_previsao);
      const year = selectedDate.getFullYear();
      const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
      const day = String(selectedDate.getDate()).padStart(2, "0");
      formattedDate = `${year}-${month}-${day}`;
    }

    const tarefaData = {
      colaborador_id: form.colaborador_id,
      nome: form.nome,
      descricao: form.descricao,
      status: form.status,
      data_previsao: formattedDate,
      atribuidor_id: atribuidorId,
      data: new Date().toISOString(),
    };

    console.log(atribuidorId)

    await services.tarefas.save({ tarefa: tarefaData, token });

    // eslint-disable-next-line require-atomic-updates
    form.colaborador_id = "";
    // eslint-disable-next-line require-atomic-updates
    form.nome = "";
    // eslint-disable-next-line require-atomic-updates
    form.descricao = "";
    // eslint-disable-next-line require-atomic-updates
    form.status = "";
    // eslint-disable-next-line require-atomic-updates
    form.data_previsao = null;

    close();
  } catch (error) {
    console.error("Erro ao salvar tarefa:", error);
    alert("Erro ao salvar tarefa. Tente novamente.");
  }
}

import { watch } from "vue";

watch(
  () => props.colaboradorId,
  (newVal) => {
    form.colaborador_id = newVal || "";
  }
);

function close() {
  emit("close");
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  width: 70vw;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  font-weight: 600;
}

.modal-content label {
  display: block;
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.modal-content input,
.modal-content select,
.modal-content textarea {
  width: 100%;
  padding: 0.4rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.buttons {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.buttons button {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.buttons button[type="submit"] {
  background-color: #56008f;
  color: white;
}

.buttons button[type="button"] {
  background-color: transparent;
  border: 2px solid #56008f;
  color: #56008f;
}
</style>
